package br.com.vvrefeicoes.portal.feature.forms

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import br.com.vvrefeicoes.portal.core.ui.theme.AppPalette
import com.composables.icons.lucide.ClipboardCheck
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.MessagesSquare
import com.composables.icons.lucide.Sprout

internal data class FormSectorStyle(
    val icon: ImageVector,
    val containerColor: Color,
    val contentColor: Color,
)

internal fun formSectorStyle(sector: FormSector): FormSectorStyle =
    when (sector) {
        FormSector.DHO ->
            FormSectorStyle(
                icon = Lucide.Sprout,
                containerColor = AppPalette.Purple100,
                contentColor = AppPalette.Purple900,
            )
        FormSector.SGI ->
            FormSectorStyle(
                icon = Lucide.ClipboardCheck,
                containerColor = AppPalette.Info100,
                contentColor = AppPalette.Info900,
            )
        FormSector.OUVIDORIA ->
            FormSectorStyle(
                icon = Lucide.MessagesSquare,
                containerColor = AppPalette.Warning100,
                contentColor = AppPalette.Warning900,
            )
    }
